export default __webpack_public_path__ + "images/Portuguese.6e18c1.jpg";